export default class Draggable {
    constructor(elmnt) {
        this.elmnt = elmnt;
        this.pos1 = 0, this.pos2 = 0, this.pos3 = 0, this.pos4 = 0;
        this.fn = null;
        this.startX = 0, this.startY = 0;
    }
    dragElement() {
        document.getElementById("sw-feature-button").onmousedown = this.dragMouseDown.bind(this);
        document.getElementById("sw-feature-button").dragstart = this.dragMouseDown.bind(this);
        document.getElementById("sw-feature-button").ontouchstart = this.dragMouseDown.bind(this);
        document.getElementById("sw-feature-button").pointerdown = this.dragMouseDown.bind(this);
        this.fn = document.getElementById('sw-feature-button').onclick;
        document.getElementById('sw-feature-button').onclick = null;
    }
      
    dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        let coordX = (e.touches)?e.touches[0].screenX:e.screenX;
        let coordY = (e.touches)?e.touches[0].screenY:e.screenY;

        // get the mouse cursor position at startup:
        this.pos3 = coordX;
        this.pos4 = coordY;
        this.startX = coordX;
        this.startY = coordY;
        document.onmouseup = this.closeDragElement.bind(this);
        document.ontouchend = this.closeDragElement.bind(this);

        // call a function whenever the cursor moves:
        document.onmousemove = this.elementDrag.bind(this);
        document.ontouchmove = this.elementDrag.bind(this);
    }
        
    closeDragElement(e) {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchmove = null;

        let coordX = (e.changedTouches)?e.changedTouches[0].screenX:e.screenX;
        let coordY = (e.changedTouches)?e.changedTouches[0].screenY:e.screenY;

        if(coordX == this.startX && coordY == this.startY) {
            //this is only a click and not a drag
            this.fn(e);
        }           
    }

    elementDrag(e) {
        e = e || window.event;

        //Chrome prevents this to be called
        // e.preventDefault();
        // calculate the new cursor position:

        let coordX = (e.touches)?e.touches[0].screenX:e.screenX;
        let coordY = (e.touches)?e.touches[0].screenY:e.screenY;

        this.pos1 = this.pos3 - coordX;
        this.pos2 = this.pos4 - coordY;
        this.pos3 = coordX;
        this.pos4 = coordY;
        // set the element's new position:
        this.elmnt.style.top = (this.elmnt.offsetTop - this.pos2) + "px";
        this.elmnt.style.left = (this.elmnt.offsetLeft - this.pos1) + "px";
    }
}